/*
 * author:范传兵
 * time 2012 11 02
 * qq:1072975615
 * descript:艺搜2.1 版本
 eg:get_arr(imgstr,mark,bw,bh);
*/
//图片预加载技术
//arr：可以是存放图片路径的一个数组，也可以是选取到的img的jquery对象；
//funLoading：每一个单独的图片加载完成后执行的操作；
//funOnLoad：全部图片都加载完成后的操作；
//var width=img.width;获取图片真实宽高
//var height=img.height;获取图片真实宽高
//funOnError：单个图片加载出错时的操作。
//make_photo_change 无变形压缩图片
/*
   //2013 1 16 发现bug  1 用户传来的url为空时会有问题
                        2 同一个json中有相同的url时会有bug
						故修改 了json转化为数组 和
						获取加载成功url的位置 arr_url两个部分
						get_pos函数取消
						范传兵
*/
function get_arr(imgstr,mark,bw,bh){
   var imgjson=eval(imgstr);
   var arr_url=[];
   $.each(imgjson,function(key,val){
   if(val.url==false||val.url==""){//判断如果传来url为空 赋值无图
      arr_url[key]="images/nopic.gif";
   }else{
      arr_url[key]=val.url;
   }
   });
   if(arr_url.length==0){
   }else{
        //全部图片都加载完成后的操作
        var imgonload=function(errors){
        }
        //每一个单独的图片加载完成后执行的操作
        var funloading=function(m,n,total,src,obj,mark,width,height,bw,bh){
			var arr_pic=make_photo_change(bw,bh,width,height);
			var pic_w=arr_pic[0];
			var pic_h=arr_pic[1];
            var img="<img width='"+pic_w+"'height='"+pic_h+"'  align='absmiddle' src='"+src+"'>";
            $(mark).eq(m).replaceWith(img).fadeIn();
        }
        //单个图片加载出错时的操作
        var funOnError=function(m,n,total,src,obj,mark,width,height,bw,bh){
//		   var arr_pic=make_photo_change(bw,bh,width,height);
//		   var pic_w=arr_pic[0];
//		   var pic_h=arr_pic[1];
           //解决加载失败时ie浏览器下图片太小  故把加载失败图片大小写死了
           var pic_w=bw;
		   var pic_h=bh;
           var img="<img width='"+pic_w+"'height='"+pic_h+"' align='absmiddle' src='images/loaderror.gif'>";
           $(mark).eq(m).replaceWith(img).fadeIn();	
        }
        loadimg(arr_url,funloading,imgonload,funOnError,mark,bw,bh);//执行图片预加载
   } 
}
function loadimg(arr,funLoading,funOnLoad,funOnError,mark,bw,bh){//执行图片预加载函数
    var numLoaded=0;
    var numError=0;
    isObject=Object.prototype.toString.call(arr)==="[object Object]" ? true : false;
    var arr=isObject ? arr.get() : arr;
    for(a in arr){
        var src=isObject ? $(arr[a]).attr("data-src") : arr[a];
        preload(src,arr[a],a);
    } 
    function preload(src,obj,s){
        var img=new Image();
        img.onload=function(){
                numLoaded++;
                var m=s
				var width=img.width;
				var height=img.height;
                funLoading && funLoading(m,numLoaded,arr.length,src,obj,mark,width,height,bw,bh);
                funOnLoad && numLoaded==arr.length && funOnLoad(numError);
        };
        img.onerror=function(){
                numLoaded++;
                numError++;
                var m=s
				var width=img.width;
				var height=img.height;
                funOnError && funOnError(m,numLoaded,arr.length,src,obj,mark,width,height,bw,bh);
        }
        img.src=src;
    } 
}
//function get_pos(arr,src){//获取图片位置
//    var num=0;
//    var pos;
//    $.each(arr,function(key,val){
//         if(val==src) pos=num;
//         num++;
//    });
//    return pos;
//}
function make_photo_change(FitWidth,FitHeight,photow,photoh){//图片等比放缩
     //FitWidth  FitHeight  图片限制宽高
	 //photow    photoh    图片真实宽高
     var image = {width:photow ,height:photoh};    
     var ImgD = {width : 0 , height : 0};
	 if(photow==0||photoh==0){
		 ImgD.width=""; 
		 ImgD.height="";
	 }else{
		  if(photow<FitWidth&&photoh<FitHeight){
			  ImgD.width=image.width; 
			  ImgD.height=image.height;
		  }else{
			   if(image.width/image.height>= FitWidth/FitHeight){          
				   ImgD.width=FitWidth;
				   ImgD.height=(image.height*FitWidth)/image.width;
			   }else{
				   ImgD.height=FitHeight;
				   ImgD.width=(image.width*FitHeight)/image.height;         
			   }   
		  }
	 }
     return [ImgD.width , ImgD.height];
}